<template>
    <div class="cafe24app-wrapper">
        <el-badge value="v0.2" class="item">
            <h1 class="title">프린팅공작소 디자인 에디터</h1>
        </el-badge>

        <el-menu :router="true"
                 :default-active="$route.path"
                 text-color="#222"
                 mode="horizontal">
            <el-menu-item :index="$ROUTE_NAMES.ROUTE_CAFE24_DASHBOARD">
                <i class="el-icon-menu"></i> 홈
            </el-menu-item>
            <el-menu-item :index="$ROUTE_NAMES.ROUTE_CAFE24_PRODUCT_LIST">
                <i class="el-icon-goods"></i>디자인 상품 목록
            </el-menu-item>
            <el-menu-item v-if="isAdmin"
                          :index="$ROUTE_NAMES.ROUTE_CAFE24_ART_LIST">
                <i class="el-icon-price-tag"></i>결과 작품 목록
            </el-menu-item>
<!--            <el-menu-item v-if="isAdmin"-->
<!--                          :index="$ROUTE_NAMES.ROUTE_CAFE24_ORDER_LIST">-->
<!--                <i class="el-icon-scissors"></i>발주 의뢰-->
<!--            </el-menu-item>-->
        </el-menu>

        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'Cafe24Layout',
        computed: {
            isAdmin() {
                return this.$store.state.auth.partner.isAdmin;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .cafe24app-wrapper::v-deep {
        padding: 30px 20px;

        .dashboard-card {
            margin: 20px 0;

            .cart-title {
                color: #444;
                font-size: 22px;

                i {
                    font-size: 20px;
                }

                &.cart-title--clickable {
                    cursor: pointer;

                    &:hover {
                        color: #222;
                    }
                }
            }

            .el-tag {
                font-size: 14px;
                letter-spacing: 1px;

                &.el-tag--mini {
                    font-size: 12px;
                }
            }
        }
    }

    .title {
        font-size: 38px;
        margin-bottom: 10px;
    }

    .el-menu-item {
        font-size: 16px;
    }
</style>